// src/components/CrearCasillero.js
import React, { useState } from 'react';
import {
  Typography,
  Button,
  Snackbar,
  Alert,
  Box,
  CircularProgress,
  TextField
} from '@mui/material';
import api, { notifyError } from '../utils/Api';

function CrearCasillero({ onRegister }) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('info');
  const [formData, setFormData] = useState({
    nombre: '',
    correo: '',
    password: '',   // 👈 usamos "password"
    cedula: '',
    telefono: '',
    direccion: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCrear = async () => {
    if (!formData.nombre || !formData.correo || !formData.password || !formData.cedula) {
      setMsg('❌ Nombre, correo, contraseña y cédula son obligatorios');
      setSeverity('error');
      setOpen(true);
      return;
    }
    if (!/\S+@\S+\.\S+/.test(formData.correo)) {
      setMsg('❌ Formato de correo inválido');
      setSeverity('error');
      setOpen(true);
      return;
    }
    if (formData.password.length < 6) {
      setMsg('❌ La contraseña debe tener al menos 6 caracteres');
      setSeverity('error');
      setOpen(true);
      return;
    }

    try {
      setLoading(true);
      setMsg('');
      setSeverity('info');

      const payload = {
        ...formData,
        correo: formData.correo.trim().toLowerCase(),
        cedula: formData.cedula.trim().toUpperCase()
      };

      // Llamada al backend usando tu helper api
      const res = await api.post('/auth/register', payload);
      // compatibilidad: algunos helpers devuelven res.data, otros devuelven res directamente
      const data = res?.data ?? res;

      console.log('Respuesta backend:', data);

      if (data?.success) {
        if (data.reutilizado) {
          setMsg(`ℹ️ Ya tienes un casillero asignado: ${data.codigo || data.casillero?.codigo}`);
          setSeverity('info');
        } else {
          setMsg(`✅ Casillero creado con éxito. Tu número de casillero es: ${data.casillero?.codigo || data.codigo}`);
          setSeverity('success');
        }
        setOpen(true);

        // Guardar token si viene en la respuesta
        if (data.token) {
          localStorage.setItem('token', data.token);
        }

        // Propagar al App principal para que guarde rol/correo/casillero
        // asumimos rol 'cliente' al crear casillero
        try {
          const correo = data?.correo || payload.correo;
          const codigo = data?.casillero?.codigo || data?.codigo || null;
          if (typeof onRegister === 'function') {
            onRegister('cliente', correo, codigo);
          }
        } catch (err) {
          console.warn('[CrearCasillero] onRegister falló:', err);
        }

        setFormData({
          nombre: '',
          correo: '',
          password: '',
          cedula: '',
          telefono: '',
          direccion: ''
        });
      } else {
        setMsg(data?.mensaje || '❌ Error en registro');
        setSeverity('error');
        setOpen(true);
      }
    } catch (err) {
      console.error('❌ Error al crear casillero:', err.response?.data || err.message || err);
      const message =
        err?.response?.data?.mensaje || err.message || '❌ Error al crear casillero.';
      notifyError(message);
      setMsg(message);
      setSeverity('error');
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>🧰 Crea tu casillero</Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Completa el formulario para obtener tu código único de casillero y tu cuenta de acceso.
      </Typography>

      <TextField label="Nombre" name="nombre" fullWidth margin="normal"
        value={formData.nombre} onChange={handleChange} disabled={loading} />
      <TextField label="Correo" name="correo" type="email" fullWidth margin="normal"
        value={formData.correo} onChange={handleChange} disabled={loading} />
      <TextField label="Contraseña" name="password" type="password" fullWidth margin="normal"
        value={formData.password} onChange={handleChange} disabled={loading} />
      <TextField label="Cédula" name="cedula" fullWidth margin="normal"
        value={formData.cedula} onChange={handleChange} disabled={loading} />
      <TextField label="Teléfono" name="telefono" fullWidth margin="normal"
        value={formData.telefono} onChange={handleChange} disabled={loading} />
      <TextField label="Dirección" name="direccion" fullWidth margin="normal"
        value={formData.direccion} onChange={handleChange} disabled={loading} />

      <Button
        variant="contained"
        color="primary"
        onClick={handleCrear}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={20} /> : null}
        sx={{ mt: 2 }}
      >
        {loading ? 'Procesando...' : 'Crear casillero'}
      </Button>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpen(false)} severity={severity} sx={{ width: '100%' }}>
          {msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default CrearCasillero;